<template>
  <div class="mod-sale-order">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item>
        <el-input v-model="dataForm.orderNo" :placeholder="$t('sale.orderNo')" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="dataForm.customerName" :placeholder="$t('sale.customerName')" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="dataForm.customerPhone" :placeholder="$t('sale.customerPhone')" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="dataForm.paymentStatus" :placeholder="$t('sale.paymentStatus')" clearable>
          <el-option :label="$t('sale.paymentStatuses.PENDING')" value="PENDING"></el-option>
          <el-option :label="$t('sale.paymentStatuses.PAID')" value="PAID"></el-option>
          <el-option :label="$t('sale.paymentStatuses.REFUNDED')" value="REFUNDED"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="dataForm.paymentMethod" :placeholder="$t('sale.paymentMethod')" clearable>
          <el-option :label="$t('sale.paymentMethods.CASH')" value="CASH"></el-option>
          <el-option :label="$t('sale.paymentMethods.WECHAT')" value="WECHAT"></el-option>
          <el-option :label="$t('sale.paymentMethods.ALIPAY')" value="ALIPAY"></el-option>
          <el-option :label="$t('sale.paymentMethods.MEMBER_BALANCE')" value="MEMBER_BALANCE"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="getDataList()">{{ $t('common.search') }}</el-button>
        <el-button type="primary" @click="addOrUpdateHandle()">{{ $t('sale.addSale') }}</el-button>
        <el-button type="success" @click="exportData()">{{ $t('sale.exportData') }}</el-button>
      </el-form-item>
    </el-form>
    
    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      @selection-change="dataListSelectionsChangeHandle"
      style="width: 100%;">
      <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
      <el-table-column prop="orderNo" header-align="center" align="center" :label="$t('sale.orderNo')"></el-table-column>
      <el-table-column prop="customerType" header-align="center" align="center" :label="$t('sale.customerType')">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.customerType === 'WALK_IN'" type="info">{{ $t('sale.customerTypes.WALK_IN') }}</el-tag>
          <el-tag v-else-if="scope.row.customerType === 'MEMBER'" type="success">{{ $t('sale.customerTypes.MEMBER') }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="customerName" header-align="center" align="center" :label="$t('sale.customerName')"></el-table-column>
      <el-table-column prop="customerPhone" header-align="center" align="center" :label="$t('sale.customerPhone')"></el-table-column>
      <el-table-column prop="totalAmount" header-align="center" align="center" :label="$t('sale.totalAmount')">
        <template slot-scope="scope">
          ¥{{ scope.row.totalAmount }}
        </template>
      </el-table-column>
      <el-table-column prop="discountAmount" header-align="center" align="center" :label="$t('sale.discountAmount')">
        <template slot-scope="scope">
          ¥{{ scope.row.discountAmount }}
        </template>
      </el-table-column>
      <el-table-column prop="actualAmount" header-align="center" align="center" :label="$t('sale.actualAmount')">
        <template slot-scope="scope">
          ¥{{ scope.row.actualAmount }}
        </template>
      </el-table-column>
      <el-table-column prop="paymentMethod" header-align="center" align="center" :label="$t('sale.paymentMethod')">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.paymentMethod === 'CASH'" type="success">{{ $t('sale.paymentMethods.CASH') }}</el-tag>
          <el-tag v-else-if="scope.row.paymentMethod === 'WECHAT'" type="success">{{ $t('sale.paymentMethods.WECHAT') }}</el-tag>
          <el-tag v-else-if="scope.row.paymentMethod === 'ALIPAY'" type="primary">{{ $t('sale.paymentMethods.ALIPAY') }}</el-tag>
          <el-tag v-else-if="scope.row.paymentMethod === 'MEMBER_BALANCE'" type="warning">{{ $t('sale.paymentMethods.MEMBER_BALANCE') }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="paymentStatus" header-align="center" align="center" :label="$t('sale.paymentStatus')">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.paymentStatus === 'PENDING'" type="warning">{{ $t('sale.paymentStatuses.PENDING') }}</el-tag>
          <el-tag v-else-if="scope.row.paymentStatus === 'PAID'" type="success">{{ $t('sale.paymentStatuses.PAID') }}</el-tag>
          <el-tag v-else-if="scope.row.paymentStatus === 'REFUNDED'" type="danger">{{ $t('sale.paymentStatuses.REFUNDED') }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="cashierName" header-align="center" align="center" :label="$t('sale.cashierName')"></el-table-column>
      <el-table-column prop="createTime" header-align="center" align="center" :label="$t('sale.createTime')"></el-table-column>
      <el-table-column fixed="right" header-align="center" align="center" width="150" :label="$t('common.operation')">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="viewDetails(scope.row.id)">{{ $t('sale.viewDetails') }}</el-button>
          <el-button type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('common.delete') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
    
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    
    <!-- 销售详情弹窗 -->
    <sale-detail v-if="saleDetailVisible" ref="saleDetail" @refreshDataList="getDataList"></sale-detail>
  </div>
</template>

<script>
  import AddOrUpdate from './order-add-or-update'
  import SaleDetail from './order-detail'
  
  export default {
    data () {
      return {
        dataForm: {
          orderNo: '',
          customerName: '',
          customerPhone: '',
          paymentStatus: '',
          paymentMethod: ''
        },
        dataList: [],
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        dataListLoading: false,
        dataListSelections: [],
        addOrUpdateVisible: false,
        saleDetailVisible: false
      }
    },
    components: {
      AddOrUpdate,
      SaleDetail
    },
    activated () {
      this.getDataList()
    },
    created () {
      this.getDataList()
    },
    methods: {
      // 获取数据列表
      getDataList () {
        this.dataListLoading = true
        const params = Object.assign({}, this.dataForm, {
          page: this.pageIndex,
          limit: this.pageSize
        })
        this.$http({
          url: 'saleorder/page',
          method: 'get',
          params
        }).then(({data}) => {
          console.log('Sale order response:', data);
          
          if (data && data.code === 0) {
            this.dataList = data.data.list
            this.totalPage = data.data.total
          } else {
            this.dataList = []
            this.totalPage = 0
          }
          this.dataListLoading = false
        }).catch((err) => {
          console.error('Sale order list load failed:', err)
          this.dataList = []
          this.totalPage = 0
          this.dataListLoading = false
        })
      },
      // 每页数
      sizeChangeHandle (val) {
        this.pageSize = val
        this.pageIndex = 1
        this.getDataList()
      },
      // 当前页
      currentChangeHandle (val) {
        this.pageIndex = val
        this.getDataList()
      },
      // 多选
      dataListSelectionsChangeHandle (val) {
        this.dataListSelections = val
      },
      // 新增 / 修改
      addOrUpdateHandle (id) {
        this.addOrUpdateVisible = true
        this.$nextTick(() => {
          this.$refs.addOrUpdate.init(id)
        })
      },
      // 查看详情
      viewDetails (id) {
        this.saleDetailVisible = true
        this.$nextTick(() => {
          this.$refs.saleDetail.init(id)
        })
      },
      // 删除
      deleteHandle (id) {
        this.$confirm(`确定对[id=${id}]进行[删除]操作?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http({
            url: 'saleorder/delete',
            method: 'post',
            data: [id]
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.getDataList()
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }).catch(() => {})
      },
      // 导出数据
      exportData () {
        this.$message.info('导出功能开发中...')
      }
    }
  }
</script>
